export type ErrorMap = {
    isError: boolean;
    message: string;
    code?: string;
};

export const errorMap = (error: Error): ErrorMap => {
    return { isError: true, message: error.message };
};
